import earlyStamp from '../assets/practice/stamps/workout_cleared_stamp_early.svg';
import selfStamp from '../assets/practice/stamps/workout_cleared_stamp_self.svg';
import standardStamp from '../assets/practice/stamps/workout_cleared_stamp_standard.svg';

const STAMPS_BY_GRADUATION_TYPE = {
  early: earlyStamp,
  score: standardStamp,
  manual: selfStamp,
};

export function getGraduationStamp(graduationType) {
  return STAMPS_BY_GRADUATION_TYPE[graduationType] || selfStamp;
}

export default getGraduationStamp;
